import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { DragDropContext } from 'react-beautiful-dnd'
// components
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
// view components
import GlobalProperties from './components/GlobalProperties'
import PlanTypeProperties from './components/PlanTypeProperties'
import PropertiesList from './components/PropertiesList'
import PropertyDetailsDrawer from 'components/Modals/PropertyDetailsModal'
// views
import {
  Accordion,
  AccordionSummary,
  AccordionDetails
} from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/view'
// themes
import { colors } from 'themes'
// context
import { ObjectsAPIContext } from 'containers/ObjectsAndProperties/Edit/layers/API'
import { ObjectsBLContext } from 'containers/ObjectsAndProperties/Edit/layers/BL'

const ObjectProperties: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState<boolean>(true)

  const { onDragStart, onDragEnd, selectedPlanType } = React.useContext(ObjectsBLContext)
  const { object, updateField } = React.useContext(ObjectsAPIContext)

  const expandPanel = (_, expanded: boolean) => setIsOpen(expanded)

  const { searchedPlanType } = useSelector((state) => ({
    searchedPlanType: formValueSelector('PLAN_TYPES_FILTER')(state, 'planType')
  }))

  return (
    <>
      <Accordion expanded={isOpen} onChange={expandPanel} isProperties>
        <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor={colors.blue500} />}>Properties</AccordionSummary>
        <AccordionDetails sx={{ display: 'flex' }}>
          <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
            <PropertiesList />
            <GlobalProperties />
            {object.name.toLowerCase() === 'plan' && <PlanTypeProperties searchedPlanType={searchedPlanType} />}
          </DragDropContext>
        </AccordionDetails>
      </Accordion>

      <PropertyDetailsDrawer object={object} updateField={updateField} selectedPlanType={selectedPlanType} />
    </>
  )
}

export default ObjectProperties
